import moment from "moment";

export const getYearsOptions = () => {
  const currentYear = moment().year();
  return [
    {label: `${currentYear}`, value: currentYear},
    {label: `${currentYear - 1}`, value: currentYear - 1},
    {label: `${currentYear - 2}`, value: currentYear - 2},
    {label: `${currentYear - 3}`, value: currentYear - 3},
    {label: `${currentYear - 4}`, value: currentYear - 4},
    {label: `${currentYear - 5}`, value: currentYear - 5},
    {label: `${currentYear - 6}`, value: currentYear - 6},
    {label: `${currentYear - 7}`, value: currentYear - 7},
    {label: `${currentYear - 8}`, value: currentYear - 8},
    {label: `${currentYear - 9}`, value: currentYear - 9},
    {label: `${currentYear - 10}`, value: currentYear - 10},
  ]
};